import React from 'react';
import style from "./style.scss";

const Image = ({ Src, classN = "" }) => {
    return (
        <img src={Src} className={classN} />
    )
}

export default Image